// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"7a4cc887","910":"2f5c9f91"}[chunkId] + ".chunk.js";
};